module.exports = __webpack_public_path__ + "static/media/friends.763f5617.svg";